import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../selectors/modals/promotions/deposit_bonus';
import {redeemPromotionDepositBonus} from '../../../reducers/modals/actions';
import PurpleButton from '../../components/purple-button';
import PromotionsUtil from '../../../utils/promotions';
import ModalsLib from '../../../lib/modals';


export default () => {
    const {button} = useSelector(Selector),
          dispatch = useDispatch();

    return (
        <div className="modal animate__animated animate__fadeInUp animate__faster promotion-modal promotion-deposit">
            <div className="modal-header">
                <div className="close" onClick={e => {
                    PromotionsUtil.closePromotionModal('no-active-deposit-bonus');
                }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 18L6 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
            <div className="modal-body">
                <div className="layer">
                    <div className="deposit-icon"></div>
                </div>
                <div className="layer">
                    <div className="content center">
                        <div className="top">
                            <div className="title">GRAB<span>20%</span><br/>DEPOSIT NOW!</div>
                            <div className="descriptions">Make a deposit from $20 and get <b>+20%</b> to your deposit!</div>
                        </div>
                        <div className="bottom">
                            <PurpleButton active={button} onClick={e => {
                                dispatch(redeemPromotionDepositBonus('no-active-deposit-bonus'));
                            }}>Make deposit</PurpleButton>
                        </div>
                    </div>
                </div>
            </div>  
        </div>
    )
}